'use client';
import { createStyles } from '@s7/styles';

/** Поставляется для сброса стилей других компонентов */ var ButtonStylesReset = {
    WebkitTapHighlightColor: "transparent",
    background: "transparent",
    // Отключение focusRing.
    outline: 0,
    border: 0,
    margin: 0,
    borderRadius: 0,
    padding: 0,
    MozAppearance: "none",
    WebkitAppearance: "none",
    "&::-moz-focus-inner": {
        borderStyle: "none"
    },
    textDecoration: "none"
};
var useStyles = createStyles({
    root: ButtonStylesReset,
    wrapper: {
        cursor: "not-allowed",
        display: "block",
        "&[data-stretch=true]": {
            display: "inline"
        },
        width: "fit-content"
    }
});

export { ButtonStylesReset, useStyles as default };
